import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Auth } from 'aws-amplify';

import {
  Router
} from "react-router-dom";

import './App.css';
import 'nvd3/build/nv.d3.min.css'
import 'intro.js/introjs.css';

import history from './history';
import Settings from './app/utils/Settings'

import AuthContainer from './app/components/Layout/AuthContainer';
import NonAuthContainer from './app/components/Layout/NonAuthContainer';
import { isAuthenticated, setError, authenticate, sessionDataRedirect } from './features/session/sessionSlice';

import NonAuthRoutes from './app/routes/NonAuthRoutes'
import AuthRoutes from './app/routes/AuthRoutes'
import { getTheme, parseTheme, setTheme, THEME_DEFAULT } from './app/utils/common';
import { SkeletonTheme } from 'react-loading-skeleton';

function App(props) {
    const dispatch = useDispatch()
    
    const isAuth = useSelector(isAuthenticated);
    const token = useSelector(state => state.session.token)
    const useDarkMode = useSelector(state => state.session.useDarkMode)

    const [state, setState] = useState({
        interval: 3600000
    })
    
    useEffect(() => {

        const theme = parseTheme()
        if(theme === null){
        let localDomain = localStorage.domain
        let origin = !window.location.host.includes("localhost") && !window.location.host.includes("staging.") ? window.location.origin : localDomain ? `https://${localDomain}` : "https://engine.internetstrategylabs.com"
        
        if(import.meta.env.MODE === "production" && origin === Settings.oldOrigin){
            window.location.href = THEME_DEFAULT.origin
        } else {
            getTheme(origin).then(({response}) => {
                setTheme(response)
                
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = response.favIcon;
            })
        }
        } else {
            if(import.meta.env.MODE === "production" && theme.origin === Settings.oldOrigin){
                window.location.href = THEME_DEFAULT.origin
            }
        }

        setInterval(async() => {
            try {
                const data = await Auth.currentSession()
                const { payload, jwtToken } = data.idToken
                
                localStorage.setItem('token', jwtToken)

                dispatch(authenticate(jwtToken))

                setState(prev => ({
                    ...prev,
                    interval: payload.exp * 1000 - new Date().getTime()
                }))
            } catch(e){
                const dt = await Auth.signOut({ global: true })
                dispatch(sessionDataRedirect())
                dispatch(setError(new Error("Session has expired")))
                localStorage.removeItem('token')
                window.location.href = '/'
            }
        
        }, state.interval)

    }, [])

    useEffect(() => {
        if(isAuth){
        let { interval } = state
        if(token){
            const payload = JSON.parse(atob(token.split('.')[1]))
            
            interval = payload.exp * 1000 - new Date().getTime() + 10000
        }
        
        setState(prev => ({
            ...prev,
            interval
        }))
        }
    }, [isAuth])

  
    if(window.location?.hash){
        const newUrl = window.location.hash.replace("#!/app/", "").replace("_", "-")
        history.push("/"+newUrl)
    }

    return <SkeletonTheme color="grey" highlightColor={useDarkMode ? "#444" : "#BBB"}>
        <Router history={history}>
            {isAuth && <AuthContainer>
                <AuthRoutes />
            </AuthContainer>}
            {!isAuth && <NonAuthContainer>
                <NonAuthRoutes />
            </NonAuthContainer>}
        </Router>
    </SkeletonTheme>
}

export default App;
